/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { Stack } from "@mui/material";
import { BoundsGrid } from "components/search/input/DifferencePanel/BoundsGrid";
import { CoefficientsSection } from "components/search/input/DifferencePanel/CoefficientsSection";
import {
  AddedItem,
  CategoryTitle,
  DiffGroupWrapper,
  DiffRow,
  RemovedItem,
} from "components/search/input/DifferencePanel/common";
import { MassDiff } from "components/search/input/DifferencePanel/MassDiff";
import { materialLimitKey } from "components/search/input/DifferencePanel/baseLookups";
import { useTenantTranslation, useUnitsFormatter } from "hooks/formatters";
import { useFormatNumber } from "src/utils/formatNumber";
import {
  DiffNameBasedMaterialLimit,
  NameBasedMaterialLimit,
} from "store/api/generatedApi";

interface Props {
  diff: DiffNameBasedMaterialLimit;
  base: NameBasedMaterialLimit | null;
}

export const MaterialLimitDiffItem = ({ diff, base }: Props) => {
  const { t } = useTenantTranslation();
  const units = useUnitsFormatter(false);
  const formatNumber = useFormatNumber();
  const formatNumber3DP = formatNumber(3);

  const { previous, updated, key } = diff;
  const isAdded = previous === null;
  const isRemoved = updated === null;

  const effectivePrevious: NameBasedMaterialLimit | null = isAdded
    ? base
    : (previous ?? null);
  const effectiveUpdated: NameBasedMaterialLimit | null = isRemoved
    ? base
    : (updated ?? null);

  const massUnit = units("mass");

  const representative = effectiveUpdated ?? effectivePrevious;
  const label = representative
    ? materialLimitKey(representative.chef_group_name, representative.name)
    : key;

  return (
    <DiffGroupWrapper>
      {isAdded ? (
        <AddedItem>{label}</AddedItem>
      ) : isRemoved ? (
        <RemovedItem>{label}</RemovedItem>
      ) : (
        <CategoryTitle>{label}</CategoryTitle>
      )}
      <Stack gap={1} sx={{ pl: 2, mt: 0.5 }}>
        <DiffRow
          title={t("hardness")}
          value={
            <MassDiff
              previous={effectivePrevious?.hardness}
              updated={effectiveUpdated?.hardness}
              massUnit=""
              format={formatNumber3DP}
            />
          }
        />
        <BoundsGrid
          previous={effectivePrevious}
          updated={effectiveUpdated}
          t={t}
          massUnit={massUnit}
          format={formatNumber3DP}
        />
        <CoefficientsSection
          previous={effectivePrevious}
          updated={effectiveUpdated}
          t={t}
          format={formatNumber3DP}
        />
      </Stack>
    </DiffGroupWrapper>
  );
};
